<template>
  <div class="new-device">
    <!--MODAL -->
    <div v-if="display" v-bind:class="{showPadding: display}">
        <div v-loading.fullscreen.lock="loading"></div>
        <el-form :model="deviceData" class="new-device-form" label-width="200px" ref="device-form">
            <el-form-item label="Pick a Device Type" prop="type" required>
              <el-select v-model="deviceData.type" placeholder="Pick a Device Type" no-data-text="No types">
                <el-option
                  v-for="item in deviceTypes"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="URL Address of Unit" prop="ip" required>
              <el-input v-model="deviceData.ip" placeholder="Enter a URL"></el-input>
            </el-form-item>
            <el-form-item label="Port Address" required prop="port">
              <el-input v-model="deviceData.port" placeholder="Enter a Port number"></el-input>
            </el-form-item>
            <el-form-item label="Name of Device" required prop="name">
              <el-input v-model="deviceData.name" placeholder="Device Name"></el-input>
            </el-form-item>
            <el-form-item label="Name of Site" prop="site" required>
              <el-select v-model="deviceData.site" placeholder="Site Name" no-data-text="No Sites">
                <el-option
                  v-for="site in sites"
                  :key="site.id"
                  :label="site.name"
                  :value="site.name">
                </el-option>
              </el-select>
              <!-- <el-input v-model="deviceData.site" placeholder="Site Name"></el-input> -->
            </el-form-item>
            <el-form-item label="Serial Number" prop="serial" required>
              <el-input v-model="deviceData.serial" placeholder="Serial Number"></el-input>
            </el-form-item>
            <div v-if="update">
             <el-button type="save" v-on:click="updateDevice()">Update Device</el-button>
             <el-button type="cancel" v-on:click="closeForm()">Cancel</el-button>
            </div>
            <div v-else>
             <el-button type="save" v-on:click="newDevice()">Save Device</el-button>
             <el-button type="cancel" v-on:click="closeForm()">Cancel</el-button>
            </div>
      </el-form>
  </div>
  </div>
</template>

<script>
  import { debounce } from "lodash";
  import requests from '../../../requests';
  export default {
    name: 'new-device',
    props:['display', 'update', 'device_id'],
    data(){
      return {
         deviceData: {
           type: '',
           ip: '',
           fields:[],
           scenes:[],
           functions:[],
           name:'',
           site: '',
           port: ''
         },
         deviceTypes: [],
         fields: [{'id': 0, 'field_name':'N/A'}],
         scenes: [],
         functions: [],
         no_relays: 4,
         loading: false,
         sites: [],
         showForm: false,
         selectedFields: [],
         sceneDisabled: [true, true, true, true, true]
       }
    },
    beforeMount(){
      var context = this;
      
      requests.getDeviceTypes(this, function(result) {
        context.deviceTypes = result.data;
      });

      requests.getDevices(this, function(result) {
        context.devices = result.data;
      });
      
      requests.getRelayFunctions(this, function(result){
        context.functions = result.data;
      });
      
      requests.getAllSites(this, function(result){
        context.sites = result.data;
      });

    },
    watch: {
      update: function(val){
        var context = this;
        
        if(this.update && this.device_id){
          this.loading = true;
          this.showForm = true;
          this.getDevice();
          for(var i = 0; i < this.sceneDisabled.length; i++){
            this.sceneDisabled[i] = false;
          }
        } else {
          // console.log('new form');
          // console.log(this.$refs["device-form"].fields);
          this.$refs["device-form"].resetFields();
        }
      },
    },
    methods: {
      newDevice() {
        var context = this;
        requests.newDevice(this, this.deviceData, function(result) {
          if (result.action == "success") {
            context.$message({
              showClose: true,
              type: 'success',
              message: 'Successfully added new device'
            });
            context.$emit('closeForm');
          } else {
            context.$message({
              showClose: true,
              type: 'error',
              message: 'Error adding new device: ' + result.msg
            });
          }
        });
      },
      updateDevice(device_id) {
        var context = this;
        requests.updateDevice(this, this.deviceData, this.device_id, function(result) {
          if (result.action == "success") {
            context.dialogVisible = false;
            context.$message({
              showClose: true,
              type: 'success',
              message: 'Successfully updated device'
            });
            context.$emit('closeForm');
          } else {
            context.$message({
              showClose: true,
              type: 'error',
              message: 'Error updating device: ' + result.msg
            });
          }
        });
      },
      closeForm(){
        this.display = false;
        this.$emit('closeForm');
      },
      getDevice: debounce(
        function(){
          var context = this;
          requests.getOneDevice(this, this.device_id, function(result){
            context.loading = false;
            
            if(!result && !result.data){
              context.$message({
                type: 'error',
                message: 'Error retrieving device'
              });
              return false;
            }
            
            var data = result.data;
            context.deviceData.type = data.type;
            context.deviceData.ip = data.ip;
            context.deviceData.port = data.port;
            context.deviceData.name = data.name;
            context.deviceData.site = data.site;
            context.deviceData.serial = data.serial;
            
          });
        }, 2000
      ),
      //Gets the changed fields ID by comparing the two arrays (val and this.selectedFields) and finding the difference
      findDifference(val){
        if(this.selectedFields){
          for(var i = 1; i <= this.no_relays + 1; i++){ //NOTE: Index off by 1 because null is [0] in val and selectedFields
            if(val && val[i] && this.selectedFields[i]){
              if(val[i] != this.selectedFields[i]){
                this.selectedFields = val.slice();
                return {'val':val[i], 'i':i};
              }
            } else {
              this.selectedFields = val.slice();
              return {'val':val[i], 'i':i};
            }
          }
        } else {
          for(var i = 1; i <= this.no_relays + 1; i++){
            if(val[i]){
              this.selectedFields = val.slice();
              return {'val':val[i], 'i':i};
            }
          }
        }
      }
    }
  }
</script>

<style>
  .new-device .new-device-form .el-select {
    width: 100%;
  }
  
  .new-device .new-device-form .el-select .el-input{
    float: left;
  }
  
  .new-device .new-device-form .el-input {
    width: 80%;
  }
  
  .new-device .el-form-item__content {
    text-align: left;
  }

  .showPadding {
    background-color: white;
    padding-top: 30pt;
    padding-bottom: 30pt;
  }
</style>


// WEBPACK FOOTER //
// NewDevice.vue?5d3b5727